import { createFileRoute, useRouter } from '@tanstack/react-router';
import { getApp } from 'firebase/app';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { useEffect } from 'react';

import {
  IMPERSONATION_APP_NAME,
  IMPERSONATION_EXPIRES_AT,
  IMPERSONATION_FLAG,
} from '../api/axios.instance';

const ImpersonateBootstrap = () => {
  const router = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');

    if (!token) {
      router.navigate({ to: '/auth/signin', replace: true });
      return;
    }

    sessionStorage.setItem(IMPERSONATION_FLAG, '1');

    const auth = getAuth(getApp(IMPERSONATION_APP_NAME));
    signInWithCustomToken(auth, token)
      .then(async (cred) => {
        const result = await cred.user.getIdTokenResult();
        const exp = result.claims.impersonationExpiresAt as string | undefined;

        if (exp) {
          sessionStorage.setItem(IMPERSONATION_EXPIRES_AT, exp);
        }

        window.history.replaceState(null, '', '/');
        router.navigate({ to: '/', replace: true });
      })
      .catch(() => {
        sessionStorage.removeItem(IMPERSONATION_FLAG);
        sessionStorage.removeItem(IMPERSONATION_EXPIRES_AT);
        router.navigate({ to: '/auth/signin', replace: true });
      });
  }, [router]);

  return null;
};

export const Route = createFileRoute('/impersonate')({
  component: ImpersonateBootstrap,
});
